import React, { useEffect, useRef } from "react"

import { Card } from "@mantine/core"

import { Icon } from "@/components"
import { Body } from "@/components/MobileAlertCard/Body"
import { useStyles } from "@/components/MobileAlertCard/MobileAlertCard.styles"

import { renderText } from "app/static/frontend/search-new/components/Inline/shared/functions"

// Uses the datasets from SEARCH_LINKS on frontend/pages/home/components/helpers
const MOBILE_DATASET_KEYS = [
    DjangIO.app.models.QuorumDataType.person.key,
    DjangIO.app.models.QuorumDataType.staffer.key,
    DjangIO.app.models.QuorumDataType.supporter.key,
    DjangIO.app.models.QuorumDataType.note.key,
    DjangIO.app.models.QuorumDataType.bill.key,
]

// accessibility based on https://css-tricks.com/block-links-the-search-for-a-perfect-solution/
export const MobileAlertCard = (props) => {
    const { classes } = useStyles()
    const isDisabled = !MOBILE_DATASET_KEYS.includes(props.quorumDataType.key)

    const bodyRef = useRef(null)
    const titleRef = useRef(null)

    useEffect(() => {
        const bodyLinks = bodyRef.current?.querySelectorAll("a")
        const stopClickPropagation = (e) => e.stopPropagation()

        bodyLinks.forEach((link) => {
            link.addEventListener("click", stopClickPropagation)
        })

        return () =>
            bodyLinks.forEach((link) => {
                link.removeEventListener("click", stopClickPropagation)
            })
    }, [])

    const handleCardClick = () => {
        titleRef.current?.click()
    }
    const handleButtonClick = (e) => {
        e.stopPropagation()

        const hasSelection = window.getSelection().toString()
        !isDisabled && !hasSelection && props.onPress()
    }

    return (
        <Card className={classes.container} shadow="sm" radius="md" withBorder onClick={handleCardClick}>
            <Card.Section className={classes.header}>
                <div className={classes.firstLine}>
                    <button
                        ref={titleRef}
                        type="button"
                        className={classes.headerTitle}
                        onClick={handleButtonClick}
                        aria-disabled={isDisabled}
                    >
                        {props.firstLineData &&
                            renderText({
                                lineData: props.firstLineData,
                                isHtml: props.firstLineIsHtml,
                                inlineId: props.inlineId,
                                isSearchify: props.isHighlightable,
                            })}
                    </button>
                    <Icon icon={"rss"} iconFamily="far" className={classes.headerIcon} />
                </div>

                <div className={classes.secondLine}>
                    <span>
                        <b>{props.quorumDataType.singular.toUpperCase()} </b>
                    </span>
                    <span> {props.regions}</span>
                    <div>Sent {props.created}</div>
                </div>
            </Card.Section>

            <Card.Section className={classes.body} ref={bodyRef}>
                <Body
                    bigCache={props.feedItemCache}
                    inlineId={props.inlineId}
                    isSearchify={props.isHighlightable}
                    quorumDataType={props.quorumDataType}
                    key={props.inlineId}
                    isMobile
                />
            </Card.Section>

            {isDisabled && (
                <Card.Section className={classes.footer}>
                    <Icon icon={"exclamation-circle"} iconFamily="far" />
                    Not available on mobile. Please view it on the desktop.
                </Card.Section>
            )}
        </Card>
    )
}
